import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  GetLabourForecastForProjectQuery,
  GetPaginatedLabourForecastsForProjectInput,
  PaginationInput,
} from '@/gql/graphql';
import { PAGINATION_ARG_DEFAULTS } from '@payaca/shared-isomorphic/constants/graphql-pagination';
import { useQuery } from '@tanstack/react-query';
import projectKeys from './keyFactory';

const GET_LABOUR_FORECAST_FOR_PROJECT = graphql(`
  query GetLabourForecastForProject(
    $projectId: ID!
    $input: GetPaginatedLabourForecastsForProjectInput
    $pagination: PaginationInput!
  ) {
    projectById(id: $projectId) {
      id
      labourForecasts(input: $input, pagination: $pagination) {
        limit
        offset
        totalCount
        totalCost {
          value
          currency {
            id
            code
            exponent
          }
        }
        items {
          id
          createdAt
          updatedAt
          description
          timeUnit
          quantity
          costPerTimeUnit {
            value
            currency {
              id
              code
              exponent
            }
          }
          totalCost {
            value
            currency {
              id
              code
              exponent
            }
          }
        }
      }
    }
  }
`);

export type LabourForecast =
  GetLabourForecastForProjectQuery['projectById']['labourForecasts']['items'][0];

const useGetLabourForecastForProject = (
  projectId?: string,
  pagination?: PaginationInput,
  input?: GetPaginatedLabourForecastsForProjectInput
) => {
  const paginationInput = pagination || PAGINATION_ARG_DEFAULTS;

  return useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.labourForecasts(projectId!, paginationInput, input),
    queryFn: () => {
      return gqlClient.request(GET_LABOUR_FORECAST_FOR_PROJECT, {
        projectId: projectId!,
        input: input,
        pagination: paginationInput,
      });
    },
  });
};

export default useGetLabourForecastForProject;
